<template>
  <ubi-panel>
    <ubi-list-header slot="header"
                     :limits="limits"
                     :total="results.total"
                     :page.sync="page"
                     :limit.sync="limit"
                     :sort.sync="sort"
                     :sortProperties="sortProperties"></ubi-list-header>
    <template slot="actions">
      <div v-if="!selected.length">
        <el-button icon="export" size="mini" v-if="!selected.length" @click="$emit('exporter')">{{
            $t("general.selection.exportAll") }}
        </el-button>
        <el-button size="mini" @click="gestionAffichageReduit(true)" v-if="!affichageReduit">
          <em class="el-icon-s-fold"></em>
          {{$t("users.listMode") }}
        </el-button>
        <el-button size="mini" @click="gestionAffichageReduit(false)" v-if="affichageReduit">
          <em class="el-icon-menu"></em>
          {{$t("users.vignetteMode") }}
        </el-button>
      </div>
      <div v-else>
          <span>
              <span class="inline">{{ $t("general.selection.forSelection") }} ({{
                  selected.length
                }}) :</span>
          <el-button-group class="inline">
            <el-button class="PostsList-export" size="mini"
                       @click="$emit('exporter', { selection: selected })">{{ $t("general.selection.export") }}</el-button>
              <el-button class="PostsList-export" size="mini"
                         @click="$emit('modal-delete-list', {quantite: selected.length, selection: selected})"> {{
                  $t("posts.list.delete")
                }}</el-button>
            <el-button class="PostsList-export" size="mini" v-if="!annonceFlux"
                       @click="$emit('switch-published', selected)">{{
                $t("general.selection.activateDeactivate")
              }}</el-button>
            <el-button class="PostsList-changeContact" size="mini" v-if="saisit_en_ligne"
                       @click="$emit('change-contacts', { selection: selected})">{{
                $t("general.selection.changeContact")
              }}</el-button>
          </el-button-group>
          </span>
      </div>
    </template>
    <ubi-list-footer
        slot="footer"
        v-if="results.total > 1"
        :limits="limits"
        :total="results.total"
        :page.sync="page"
        :limit.sync="limit"
        :sort.sync="sort"
        :sortProperties="sortProperties"
    ></ubi-list-footer>
    <el-table ref="table"
              :data="results.list"
              v-loading="loading"
              @select="selectedChanged"
              @select-all="selectAllChanged"
              v-on:open-delete-modal="openDeleteModal($event)"
    >
      <el-table-column
              fixed
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column fixed :label="$t('components.lists.columnThumbnails')" width="150">
        <template v-slot="{ row: result }">
          <img width="80" v-if="result.photoPrincipale != null"
               alt=""
               :src="result.photoPrincipale.url_miniature"
               :srcset="result.photoPrincipale.url_miniature"
          />
          <div v-else style="text-align: center;">
            <ubi-icon class="no-photo" name="camera" size='60'/>
          </div>
          <div v-if="(result.photoPrincipale != null) && (result.etat == 'V') && !result.photoPrincipale.url.includes('sold_product')">
            <img :src="'Images/' + imageBv" height="20" width="80" alt="" style="opacity: 0.75; position: absolute; bottom: 12px;" />
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="labelDiffusee">
        <template v-slot="{ row: result }">
          <div v-if="(result.nbDiffusions > 0) && (result.nbPortailsActifs > 0)">
            <div class="text-center"><em class="el-icon-success text-success mr-2" style="font-size: 1.9em;"></em></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="dateCreation" sortable :label="$t('portals.report.columnDateCreation')" min-width="150">
        <template v-slot="{ row: result }">
          {{result.dateCreation.substring(0,10)}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('contacts.listColumnReference')" min-width="150">
        <template v-slot="{ row: result }">
          {{result.reference}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('dashboard.cmColumnTitle')" min-width="200">
        <template v-slot="{ row: result }">
          <div :span="12" v-if="result.titre.length>47">
            {{result.titre.substring(0,32)}} (...)
          </div>
          <div :span="12" v-if="result.titre.length<=47">
            {{ result.titre}}
          </div>
        </template>
      </el-table-column>
        <el-table-column :label="$t('posts.list.postsCity')" min-width="200">
            <template v-slot="{ row: result }">
                {{result.donnees.ville ? result.donnees.ville.valeur : ''}}
            </template>
        </el-table-column>
      <el-table-column :label="$t('contacts.postPrice')"  v-if="!isPromoteur || (isPromoteur && filter.annonceParente)" min-width="230">
        <template v-slot="{ row: result }">
          {{result.prixDisplay}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('contacts.listColumnContacts')">
        <template v-slot="{ row: result }">
          <router-link
              :to="{ name: 'contacts-posts-detail', params: { post: result.reference}}"
              class="lienContactsListeAnnonces">
            <div class="text-center">{{result.nbContactsMailtracking}}</div>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column :label="$t('portals.list.columnActivate')" >
        <template v-slot="{ row: result }">
          <div v-if="result.etatAnnonce == 'Active'">
            <div class="text-center"><em class="el-icon-success text-success mr-2" style="font-size: 1.9em;"></em></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" :label="$t('portals.list.columnActions')" align="center" min-width="100" class="column-right-fixed">
        <template v-slot="{ row: result }">
          <el-dropdown class="inline">
            <el-button size="mini" icon="more" type="success"
                       @click.prevent.native=""></el-button>
            <el-dropdown-menu slot="dropdown">
              <a @click="gererLots(result.id)" v-if="result.typeObjet >= 3000 && result.typeObjet < 4000 && result.etat !== 'M'">
                <el-dropdown-item>
                  {{ $t("posts.card.manageLots") }}
                </el-dropdown-item>
              </a>
              <a @click="$emit('switch-published', result.id)" v-if="result.sourceCode == 'SAISIE_IMMO'">
                <el-dropdown-item>
                  {{ $t("general.selection.activateDeactivate") }}
                </el-dropdown-item>
              </a>
              <router-link
                  :to="{ name: 'post-view', params: { post: result.id } }"
              >
                <a @click="eventAnalytics('fiche_produit')">
                  <el-dropdown-item
                      v-if="((result.typeObjet < 3000 || result.typeObjet >= 4000) || possedeContactManager == false) && (!isSubUser || (isSubUser && result.etat !== 'M'))">
                    {{ $t("posts.card.details") }}
                  </el-dropdown-item>
                </a>
              </router-link>
              <router-link
                  v-if="saisit_en_ligne" :to="{ name: 'post-edit', params: { id: result.id }, query: { saisie: result.sourceCode } }">
                <el-dropdown-item>
                  {{ $t("posts.card.edit") }}
                </el-dropdown-item>
              </router-link>
              <router-link v-if="result.etat != 'M' && result.etat != 'B'" :to="{name :'portals-selection-post', params: { post : result.id }}">
                <el-dropdown-item>
                  {{ $t("posts.card.diffuse") }}
                </el-dropdown-item>
              </router-link>
              <div v-if="saisit_en_ligne && result.etat == 'M'">
                <a @click="$emit('open-use-model-modal', {id:result.id})">
                  <el-dropdown-item>
                    {{ $t("posts.card.useThisModel") }}
                  </el-dropdown-item>
                </a>
              </div>
              <div v-if="saisit_en_ligne && result.etat != 'M'">
                <a @click="$emit('open-duplicate-modal', {id:result.id})">
                  <el-dropdown-item >
                    {{ $t("posts.card.duplicate") }}
                  </el-dropdown-item>
                </a>
              </div>
              <div v-if="!result.donnees.date_debut_diffusion && result.etat !== 'M' && result.etat !== 'A'">
                <a @click="$emit('diffuse-later', {id:result.id, diffuseLaterDate:result.donnees.date_debut_diffusion})">
                  <el-dropdown-item>
                    {{ $t('posts.list.diffuseLater.planDiffusion') }}
                  </el-dropdown-item>
                </a>
              </div>
              <div v-if="sitimmoUser.garantiePublication && result.etat != 'M'">
                <router-link
                    :to="{name :'attendance-report-post', params: { post : result.id }}">
                  <a @click="eventAnalytics('rapport_presence')">
                    <el-dropdown-item>
                      {{ $t("posts.card.presenceReport") }}
                    </el-dropdown-item>
                  </a>
                </router-link>
              </div>
              <div   v-if="saisit_en_ligne && (!isSubUser || (isSubUser && result.etat !== 'M'))">
                <a @click="openDeleteModal(result.id)"  v-if="saisit_en_ligne && (!isSubUser || (isSubUser && result.etat !== 'M'))">
                  <el-dropdown-item>
                    {{ $t("posts.list.delete") }}
                  </el-dropdown-item>
                </a></div>
              <router-link :to="{ name: 'private-note', params: { id: result.id }, query: { saisie: result.sourceCode } }" v-if="result.etat !== 'M'">
                <el-dropdown-item>
                  <div @click="eventAnalytics('acces_note_privee')">{{ $t("posts.card.privateNote") }}</div>
                </el-dropdown-item>
              </router-link>
              <router-link :to="{ name: 'manage-posts', params: { id: result.id } }" v-if="filter.annonceParente == null && isPromoteur && result.etat !== 'M'">
                <el-dropdown-item>
                  <div @click="eventAnalytics('gerer_posts')">{{ $t("posts.card.managePosts") }}</div>
                </el-dropdown-item>
              </router-link>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </ubi-panel>
</template>

<script>
import ElButton from '../../../../components/Button'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'TableListImmo',
  components: {
    ElButton
  },
  props: ['affichageReduit', 'limits', 'total', 'sortProperties', 'annonceFlux', 'unselect'],
  data () {
    return {
      referenceDuplication: null,
      selected: [],
      loading: false,
      labelDiffusee: this.$t('components.lists.diffusee'),
      imageBv: 'filtre-bv.png'
    }
  },
  watch: {
    unselect: function (val) {
      this.selected = []
    }
  },
  computed: {
    ...mapState('postsListImmo', ['filter', 'results']),
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts']),
    ...mapGetters('lamotte', ['getAdvertisers']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return this.sitimmoUser.possede_contact_manager
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    saisit_en_ligne () {
      return (this.sitimmoUser.saisit_annonces_en_ligne === true || this.sitimmoUser.saisit_en_ligne_et_flux === true)
    },
    packExpert () {
      return this.sitimmoUser.packDiffusion === 'pack_expert'
    },
    garantiePublication () {
      return this.sitimmoUser.garantiePublication === 'true'
    },
    nbStocks () {
      return this.sitimmoUser.stocks.length
    },
    stocks () {
      return this.sitimmoUser.stocks
    },
    saveFilters () {
      return this.$store.state.saveFilters
    },
    userFilter () {
      return this.filter.user
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.filter.page = value
        // this.fetchList()
        this.$emit('load-data')
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.filter.page = 1
        // this.fetchList()
        this.$emit('load-data')
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.filter.page = 1
        this.$emit('load-data')
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduire: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 47)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduireRef: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 15)
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    ...mapMutations('postsListImmo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter',
      'setObjectType'
    ]),
    ...mapMutations('dialogsPostsListImmo', [
        'SET_POST_TO_DELETE',
        'SET_MODAL_DELETE'
    ]),
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    async doSelect (type) {
      if (type === '*') {
        this.selected = []
        const tmpSelection = this.results.list.map(({ id }) => id)
        this.selected = this.selected.concat(tmpSelection)
      }
      if (type === null) {
        const tmpSelection = this.results.list.map(({ id }) => id)
        this.selected = []
      }
    },
    setLabelDiffusee () {
      if (this.getAdvertisers.includes(this.sitimmoUser.id)) {
        this.labelDiffusee = this.$t('components.lists.valide')
      }
    },
    gestionAffichageReduit (rep) {
      this.$emit('affichage-reduit', rep)
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        const self = this
        this.results.list.forEach(function (item) {
          const index = self.selected.indexOf(item.id)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
      } else { // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.id === row.id) {
          add = true
        }
      })

      const index = this.selected.indexOf(row.id)

      if (add) {
        if (index === -1) {
          this.selected.push(row.id)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    },
    gererLots (id) {
      // entre programmes et lots, on reset des filtres
      this.filter.search = null
      this.filter.objectTypes = null
      this.filter.priceGt = null
      this.filter.priceLt = null
      this.filter.surfaceGt = null
      this.filter.surfaceLt = null
      this.filter.annoncesActivees = true
      this.$emit('annonce-parente', id)
    },
    openDeleteModal(id) {
      this.SET_POST_TO_DELETE(id)
      this.SET_MODAL_DELETE(true)
    }
  },
  beforeMount () {
    this.setLabelDiffusee()
    if (this.sitimmoUser.bandeauBvCouleur) {
      this.imageBv = 'filtre-bv-' + this.sitimmoUser.bandeauBvCouleur + '.png'
    }
  }
}
</script>

<style>

</style>
